<template>
    <div
        :style="commonConfigStyles"
        class="o-modal-item-tile-info"
    >
        <div class="info-wrapper">
            <div class="tile-info__info">
                <div class="tile-info__title">
                    {{ $t('ui.information', 'Information')}}
                </div>
                <div class="tile-info__text" v-html="content" />
            </div>
            <div class="tile-info__item tile-info__item--schedule" v-if="workingHours">
                <div class="tile-info__item-icon-wrapper">
                    <div class="tile-info__item-icon">
                        <svg-icon
                            original
                            name="icons/clock"
                        />
                    </div>
                    <div class="tile-info__title">
                        {{ $t('ui.schedule.tile', 'Öppettider')}}
                    </div>
                </div>   
                <div class="tile-info__text">
                    <AWorkingHours :item="item"/>
                </div>
            </div>
            <div 
                class="tile-info__item tile-info__item--floor"
                v-if="floor"
            >
                <div class="tile-info__item-icon-wrapper">
                    <div class="tile-info__item-icon">
                        <svg-icon
                            original
                            name="icons/floor"
                        />
                    </div>
                    <div class="tile-info__title">
                        {{ $t('ui.floor', 'Plan')}}
                    </div>
                </div>   
                <div class="tile-info__text">
                    {{floor}}
                </div>
            </div>
            <div 
                class="tile-info__item tile-info__item--adress"
                v-if="location"
            >
                <div class="tile-info__item-icon-wrapper">
                    <div class="tile-info__item-icon">
                        <svg-icon
                            original
                            name="icons/adress"
                        />
                    </div>
                    <div class="tile-info__title">
                        {{ $t('ui.adress', 'Adress')}}
                    </div>
                </div>   
                <div class="tile-info__text">
                    {{location}}
                </div>
            </div>

            <div 
                class="tile-info__item tile-info__item--web"
                v-if="homePage"
            >
                <div class="tile-info__item-icon-wrapper">
                    <div class="tile-info__item-icon">
                        <svg-icon
                            original
                            name="icons/web"
                        />
                    </div>
                    <div class="tile-info__title">
                        {{ $t('ui.web', 'Hemsida')}}
                    </div>
                </div>   
                <div class="tile-info__text">
                    {{homePage}}
                </div>
            </div>
            <div 
                class="tile-info__item tile-info__item--phone"
                v-if="phone"
            >
                <div class="tile-info__item-icon-wrapper">
                    <div class="tile-info__item-icon">
                        <svg-icon
                            original
                            name="icons/phone-2"
                        />
                    </div>
                    <div class="tile-info__title">
                        {{ $t('ui.phone', 'Telefon')}}
                    </div>
                </div>   
                <div class="tile-info__text">
                    {{phone}}
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import AWorkingHours from "@/components/atoms/a-working-hours/a-working-hours";

export default {
    name: 'OModalItemTileInfo',
    components: {
        AWorkingHours
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters([
            't',
            't2',
            'getPropsMapping',
            'getMapConfigProp',
            'getDenormalisedObjectById'
        ]),
        commonConfigStyles() {
            return this.getMapConfigProp('components.OModalItemTileInfo.styles') || null;
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OModalItemTileInfo.params') || {};
        },
        phone() {
            return this.t(this.item, 'phone') || '';
        },
        content() {
            return this.t(this.item, 'short_description', '');
        },
        workingHours() {
            return this.t(this.item, 'working_hours') || '';
        },
        homePage() {
            return this.item.meta.website_url;
        },
        floor() {
            const obj = this.getDenormalisedObjectById(this.item.id)
            return this.t2(obj, 'floor') || _.capitalize(_.replace(obj?.floor?.building_index, '_', ' '))
        },
        location() {
            const obj = this.getDenormalisedObjectById(this.item.id)
            return  this.t2(obj, 'location') ||  this.t(obj?.floor, 'name')
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" scoped />
